
if (typeof window !== 'undefined' && window.ResizeObserver && !window.ResizeObserver.isFrameDeferred) {
    const NativeResizeObserver = window.ResizeObserver;

    class FrameDeferredResizeObserver extends NativeResizeObserver {
        constructor(callback) {
            super((entries, observer) => {
                window.requestAnimationFrame(() => callback(entries, observer));
            });
        }
    }

    FrameDeferredResizeObserver.isFrameDeferred = true;
    window.ResizeObserver = FrameDeferredResizeObserver;
}
